import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/arrow-right.svg'


const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-2 mb-2"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "lg:max-w-[170px] md:w-[100%] sm:w-[145px]" }
const _hoisted_4 = { class: "m-auto float-right" }

import { RichText, Link } from '@sitecore-jss/sitecore-jss-vue';
import { useI18n } from 'vue-i18n';
import SectionPanel from '@/components/SectionPanel/SectionPanel.vue';
import { IFormStep, IQuote } from '@/interfaces';
import { FormAnalyticsBuilder } from '@/utils/form-analytics-builder';
import { FormEvents } from '@/enums/form-events.enum';
import { OrdinalNumbers } from '@/constants/ordinal-numbers.const';

export interface IBenefitsBrands {
  brands: any[];
  benefitsLink: any;
  title: string;
  subTitle: string;
  moreOffersText: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipBenefitsBrands',
  props: {
    brandDetails: {},
    step: {},
    quote: {}
  },
  setup(__props: any) {

const translation = useI18n();

const props = __props;

function getLink(brand: any) {
  const useBrandLink = (brand.fields.link?.value?.length ?? 0) > 0;
  return useBrandLink ? brand.fields.link : props.brandDetails?.benefitsLink;
}

function pushAnalytics(name: string) {
  if (props.quote) {
    const formAnalytics = new FormAnalyticsBuilder(props.quote, FormEvents.CROSS_SELL_CLICK, translation);
    formAnalytics.populateNavigation(name, props.brandDetails?.benefitsLink?.value?.url);
    formAnalytics.pushAnalytics();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SectionPanel, {
    title: { value: _ctx.brandDetails?.title ?? '' },
    description: { value: _ctx.brandDetails?.subTitle ?? '' },
    greyBg: { value: true }
  }, {
    sectionPanelContent: _withCtx(() => [
      (_ctx.brandDetails?.brands)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandDetails.brands, (brand, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "flex items-center gap-4 rounded border-solid border-racq-pale-blue-border bg-racq-true-white border-2 p-4 mb-1"
              }, [
                _createElementVNode("img", {
                  src: brand.fields.brand.value.src,
                  alt: brand.fields.brand.value.alt,
                  class: "h-14 w-14 mt-1"
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(RichText), {
                    field: brand.fields.benefitHeading,
                    class: "text-m-bold overflow-ellipsis whitespace-nowrap overflow-hidden -tracking-[0.15px]"
                  }, null, 8, ["field"]),
                  _createVNode(_unref(RichText), {
                    field: brand.fields.benefitText,
                    class: "line-clamp-2"
                  }, null, 8, ["field"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (brand.fields.link || _ctx.brandDetails?.benefitsLink)
                    ? (_openBlock(), _createBlock(_unref(Link), {
                        key: 0,
                        field: getLink(brand),
                        onClick: () => pushAnalytics(`${_unref(OrdinalNumbers)[index]} link`)
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "Right pointing arrow icon",
                            class: "max-w-none h-[20px] w-[21px]"
                          }, null, -1)
                        ])),
                        _: 2
                      }, 1032, ["field", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Link), {
        field: _ctx.brandDetails?.benefitsLink,
        class: "text-base-bold",
        onClick: _cache[0] || (_cache[0] = () => pushAnalytics(_ctx.brandDetails.moreOffersText))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.brandDetails.moreOffersText), 1)
        ]),
        _: 1
      }, 8, ["field"])
    ]),
    _: 1
  }, 8, ["title", "description"]))
}
}

})